import React from 'react';
import { X } from '@phosphor-icons/react';

/**
 * Removable filter chip bar.
 * chips: [{ id, label, onRemove? }]
 */
export default function FilterChips({ chips = [], onClearAll, className = '' }) {
  if (!chips.length) return null;

  return (
    <div className={`wd-filter-chips ${className}`.trim()} role="list" aria-label="Active filters">
      {chips.map((chip) => (
        <span key={chip.id} className="wd-filter-chip" role="listitem">
          <span>{chip.label}</span>
          {chip.onRemove ? (
            <button
              type="button"
              className="wd-filter-chip-remove"
              onClick={chip.onRemove}
              aria-label={`Remove ${chip.label}`}
            >
              <X size={12} weight="bold" />
            </button>
          ) : null}
        </span>
      ))}
      {onClearAll ? (
        <button type="button" className="wd-filter-clear" onClick={onClearAll}>
          Clear all
        </button>
      ) : null}
    </div>
  );
}
